import {z} from 'zod';

const multiStringParam = z.union([z.string(), z.array(z.string())]).optional();

export const directSalesQuerySchema = z.object({
  closedFrom: z.string().optional(),
  closedTo: z.string().optional(),
  branch: multiStringParam,
  variant: multiStringParam,
});

export type DirectSalesQuery = z.infer<typeof directSalesQuerySchema>;
